import { useState } from "react";
import { motion } from "framer-motion";
import { Share, PlusSquare, X, BellRing } from "lucide-react";

function isIOS() {
  const ua = navigator.userAgent || "";
  return /iphone|ipad|ipod/i.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
}

function isStandalone() {
  return window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true;
}

export default function IosInstallHint() {
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem("routerev_ios_hint_dismissed") === "true"
  );

  if (dismissed || !isIOS() || isStandalone()) return null;

  const close = () => {
    localStorage.setItem("routerev_ios_hint_dismissed", "true");
    setDismissed(true);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      className="mb-4 rounded-xl border border-brand/20 bg-brand/5 p-4"
      data-testid="ios-install-hint"
    >
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-md bg-brand/10 text-brand flex items-center justify-center shrink-0">
          <BellRing size={17} strokeWidth={1.5} />
        </div>
        <div className="min-w-0 flex-1">
          <div className="font-semibold text-sm">Get reminders even when jeeo is closed</div>
          <div className="text-sm text-muted-foreground mt-0.5 flex flex-wrap items-center gap-x-1 gap-y-1">
            On iPhone, tap
            <Share size={14} strokeWidth={1.8} className="inline text-brand" />
            <span className="font-medium text-foreground">Share</span>
            then
            <PlusSquare size={14} strokeWidth={1.8} className="inline text-brand" />
            <span className="font-medium text-foreground">Add to Home Screen</span>
            — the live countdown works here either way.
          </div>
        </div>
        <button
          data-testid="ios-hint-dismiss"
          onClick={close}
          className="p-1.5 rounded-md hover:bg-brand/10 text-muted-foreground transition-colors shrink-0"
          aria-label="Dismiss"
        >
          <X size={16} strokeWidth={1.5} />
        </button>
      </div>
    </motion.div>
  );
}
